module.exports = __webpack_public_path__ + "static/media/logo.d724c75c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layout/logo.svg
// module id = 1513
// module chunks = 0